import React from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import Overlay from 'js/components/common/Overlay';
import { Button } from 'js/components/common/Button';
import { useAppSelector } from 'js/store/hooks';

import { onReconnect } from './helpers';

import style from './Reconnect.scss';

export const Reconnect = () => {
    const isReconnectVisible = useAppSelector(prop('isReconnectVisible'));
    const translate = useTranslations('playtech.mobile.system.');

    return isReconnectVisible
        ? (
            <div className={style.container}>
                <Overlay />
                <div className={style.content}>
                    <p>{translate('message.reconnect')}</p>
                    <Button
                        color="info"
                        size="medium"
                        view="secondary"
                        onClick={onReconnect}
                        className={style.button}
                    >
                        {translate('button.reconnect')}
                    </Button>
                </div>
            </div>
        )
        : null;
};
